import React from 'react';
import { CollectionTitle } from './Title.style';

const Title = ({ title }) => {
  return <CollectionTitle>{title}</CollectionTitle>;
};

export default Title;
